import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`À propos de moi`}</h2>
    <p>{`Je suis un étudiant à l'ESGI, qui travaille en alternance chez H'ability, en tant que développeur VR Unity. J'aime travailler en équipe, et me lancer des challenges. D'un esprit assez vif, à l'écoute et patient, j'apprends en permanence.`}</p>
    <p>{`Je maitrise le C#, Unity, Python, le Java et le SQL. Je travaille sur Linux aussi bien que sur Windows. J'aimerais poursuivre mon cursus en alternance, pour rencontrer de nouvelles personnes, et résoudre de nouveaux problèmes.‎`}</p>
    <br></br>
    <br></br>
    <h2>{`Me contacter`}</h2>
    <p>{`Retrouvez moi sur `}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/pierre-durand-95719518a/"
      }}>{`LinkedIn`}</a>{`, ou `}<a parentName="p" {...{
        "href": "mailto:pierre.durand95360@gmail.com?subject=Portfolio"
      }}>{`envoyez moi un mail`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      